import type { CostSidebarItem, SortProviderSidebarItemsParams } from '../types';

const resolveAmountCents = ({ amountCents }: CostSidebarItem): number => amountCents ?? -1;

const sortProviderSidebarItems = ({
    items,
    sortDirection,
}: SortProviderSidebarItemsParams): CostSidebarItem[] =>
    [...items].sort((firstItem, secondItem) => {
        const amountDifference = resolveAmountCents(firstItem) - resolveAmountCents(secondItem);
        if (amountDifference !== 0) {
            return sortDirection === 'desc' ? -amountDifference : amountDifference;
        }
        return firstItem.label.localeCompare(secondItem.label);
    });

export default sortProviderSidebarItems;
